import { render, staticRenderFns } from "./GiftCardsFilter.vue?vue&type=template&id=09197cec&scoped=true"
import script from "./GiftCardsFilter.vue?vue&type=script&lang=js"
export * from "./GiftCardsFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09197cec",
  null
  
)

export default component.exports